const PIN_REPORT = 'PIN_REPORT'
const UNPIN_REPORT = 'UNPIN_REPORT'
const REORDER_PINNED_REPORTS = 'REORDER_PINNED_REPORTS'

export { PIN_REPORT, UNPIN_REPORT, REORDER_PINNED_REPORTS }

const pinnedReportsReducer = (state = [], action) => {
    switch (action.type) {
        case PIN_REPORT: {
            const slug = action.slug
            if (!slug || state.includes(slug)) {
                return state
            }
            return [...state, slug]
        }
        case UNPIN_REPORT:
            return state.filter((slug) => slug !== action.slug)
        case REORDER_PINNED_REPORTS:
            return Array.isArray(action.payload) ? action.payload : state
        default:
            return state
    }
}

export default pinnedReportsReducer
